/* PD Livraison estimée « Livrée entre le [debut] et le [fin] » : jours ouvrés, sans week-ends ni fériés
   français, date de Paris ; jour 1 = premier jour ouvré qui suit la commande, quelle que soit l'heure.
   Partagé par la fiche produit (pd-fp.js), le panier (pd-cart.js) et le Dressing de Princesse. */
(function () {
  if (window.PdDelivery) return;

  function easterSunday(year) {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(year, month - 1, day);
  }

  const holidayCache = {};
  function frenchHolidays(year) {
    if (holidayCache[year]) return holidayCache[year];
    const DAY = 86400000;
    const easter = easterSunday(year);
    holidayCache[year] = new Set([
      Date.UTC(year, 0, 1), // Jour de l'an
      easter + DAY, // Lundi de Pâques
      Date.UTC(year, 4, 1), // Fête du travail
      Date.UTC(year, 4, 8), // Victoire 1945
      easter + 39 * DAY, // Ascension
      easter + 50 * DAY, // Lundi de Pentecôte
      Date.UTC(year, 6, 14), // Fête nationale
      Date.UTC(year, 7, 15), // Assomption
      Date.UTC(year, 10, 1), // Toussaint
      Date.UTC(year, 10, 11), // Armistice
      Date.UTC(year, 11, 25), // Noël
    ]);
    return holidayCache[year];
  }

  const isBusinessDay = (date) => {
    const day = date.getUTCDay();
    if (day === 0 || day === 6) return false;
    return !frenchHolidays(date.getUTCFullYear()).has(date.getTime());
  };

  const nextBusinessDay = (date) => {
    const d = new Date(date.getTime());
    do {
      d.setUTCDate(d.getUTCDate() + 1);
    } while (!isBusinessDay(d));
    return d;
  };

  const addBusinessDays = (date, count) => {
    let d = new Date(date.getTime());
    for (let i = 0; i < count; i += 1) d = nextBusinessDay(d);
    return d;
  };

  function parisNow() {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Paris',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    }).formatToParts(new Date());
    const get = (type) => Number(parts.find((p) => p.type === type).value);
    return new Date(Date.UTC(get('year'), get('month') - 1, get('day')));
  }

  /* Premier et dernier jour de livraison (dates UTC) : jour 1 = premier jour ouvré qui suit la commande
     (commande du week-end → lundi) ; début = min-ième jour ouvré, fin = max-ième. Pas d'heure limite. */
  function range({ min, max }) {
    const minDays = Number(min) || 7;
    const maxDays = Math.max(minDays, Number(max) || 10);
    const today = parisNow();
    return { first: addBusinessDays(today, minDays), last: addBusinessDays(today, maxDays) };
  }

  /* Dates formatées { '[debut]': 'mar. 10 nov.', '[fin]': 'lun. 16 nov.' } */
  function dates(options) {
    const { first, last } = range(options);
    const format = (d) =>
      d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
    return { '[debut]': format(first), '[fin]': format(last) };
  }

  /* Version courte « Chez vous du mer. 4 au lun. 9 nov. » (mois répété seulement s'il change) ;
     weekday: false → « Chez vous du 4 au 9 nov. ». Dates en gras, construit en nœuds. */
  function renderShort(target, options, { prefix = 'Chez vous du', middle = 'au', weekday = true } = {}) {
    const { first, last } = range(options);
    const part = (d, withMonth) => {
      const day = weekday ? `${d.toLocaleDateString('fr-FR', { weekday: 'short', timeZone: 'UTC' })} ` : '';
      const month = withMonth ? ` ${d.toLocaleDateString('fr-FR', { month: 'short', timeZone: 'UTC' })}` : '';
      return `${day}${d.getUTCDate()}${month}`;
    };
    const sameMonth = first.getUTCMonth() === last.getUTCMonth() && first.getUTCFullYear() === last.getUTCFullYear();
    const strong = (text) => {
      const node = document.createElement('strong');
      node.textContent = text;
      return node;
    };
    target.replaceChildren(
      document.createTextNode(`${prefix} `),
      strong(part(first, !sameMonth)),
      document.createTextNode(` ${middle} `),
      strong(part(last, true))
    );
  }

  /* Écrit le texte de l'éditeur dans target, dates en gras ; construit en nœuds (pas d'HTML injecté) */
  function render(target, template, options) {
    const values = dates(options);
    target.replaceChildren();
    String(template || '').split(/(\[debut\]|\[fin\])/).forEach((part) => {
      if (values[part]) {
        const strong = document.createElement('strong');
        strong.textContent = values[part];
        target.appendChild(strong);
      } else if (part) {
        target.appendChild(document.createTextNode(part));
      }
    });
  }

  window.PdDelivery = { range, dates, render, renderShort };
})();
